import { render } from "./TrainingRecommendation.vue?vue&type=template&id=0fd50d5a&scoped=true"
import script from "./TrainingRecommendation.vue?vue&type=script&lang=js"
export * from "./TrainingRecommendation.vue?vue&type=script&lang=js"

import "./TrainingRecommendation.vue?vue&type=style&index=0&id=0fd50d5a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fd50d5a"]])

export default __exports__